module.exports = new __parcel__URL__("padlock-key-darkmode.78fd8599.svg").toString();